<template>
	<section class="dim-popup-wrap" :id="`${propData.id}`">
		<section class="dim-popup-mark" @click="close"></section>
		<section class="dim-popup-content">
			<div class="button ok" @click="close">확인</div>
			<div class="content">
				<div class="head">
					{{ propData.title }}
				</div>
				<div class="body">
					{{ propData.msg }}
				</div>
			</div>
		</section>
	</section>
</template>

<script>
import { popOpenAndScrollNone, popCloseAndScrollAuto } from '@/utils/UtilPopup';

export default {
	props: {
		propData: {
			type: Object,
			required: true,
			default: () => {
				return { title: '', msg: '', id: '' };
			}
		}
	},
	methods: {
		close() {
			popCloseAndScrollAuto(`#${this.propData.id} .dim-popup-mark`, `#${this.propData.id} .dim-popup-content`);
		},
		open() {
			popOpenAndScrollNone(`#${this.propData.id} .dim-popup-mark`, `#${this.propData.id} .dim-popup-content`);
		}
	}
};
</script>

<style scoped>
.dim-popup-content {
	width: 70%;
}
.dim-popup-content .content .head {
	font-size: 2.5rem;
	font-family: 'NotoBold';
}
.dim-popup-content .content .body {
	min-height: 150px;
	max-height: 500px;
	margin: 10px 0;
	font-size: 2rem;
	font-family: 'NotoRegular';
	text-align: left;
	word-break: break-word;
	overflow: auto;
}
</style>
